import { createAction, props } from '@ngrx/store';
import { ShopData } from '../../models';

export const LoadShopData = createAction('[Shop] Load Shop data');
export const LoadShopDataSuccess = createAction('[Shop] Load Shop data Success', props<{ data: ShopData }>());
export const LoadShopDataFail = createAction('[Shop] Load Shop data Fail', props<{ errors: any }>());
